export const DOCUMENT_TYPES = {
  PASSPORT: "PASSPORT",
  DIPLOM: "DIPLOM",
  POSITION_HISTORY: "POSITION_HISTORY",
  CRIMINAL_RECORDS: "CRIMINAL_RECORDS",
  NARCO_DISPANSER: "NARCO_DISPANSER",
  PSYCHO_DISPANSER: "PSYCHO_DISPANSER",
  INTERN: "INTERN",
  POSITION: "POSITION"
};

export const APPLICATION_TYPES = {
  QUALIFICATION_EXAM: "QUALIFICATION_EXAM",
  OATH: "OATH"
};
